import { render } from "./Texasauto.vue?vue&type=template&id=4d4f4c0a&scoped=true"
import script from "./Texasauto.vue?vue&type=script&lang=js"
export * from "./Texasauto.vue?vue&type=script&lang=js"

import "./Texasauto.vue?vue&type=style&index=0&id=4d4f4c0a&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4f4c0a"]])

export default __exports__